(function () {
    var TR = {
        required: 'Bu alan zorunludur.',
        email: 'Lütfen geçerli bir e-posta adresi giriniz.',
        url: 'Lütfen geçerli bir URL giriniz.',
        date: 'Lütfen geçerli bir tarih giriniz.',
        number: 'Lütfen geçerli bir sayı giriniz.',
        digits: 'Lütfen sadece rakam giriniz.',
        integer: 'Lütfen tam sayı giriniz.',
        alphanumeric: 'Sadece harf, rakam ve alt çizgi kullanınız.',
        nowhitespace: 'Boşluk kullanmayınız.',
        creditcard: 'Lütfen geçerli bir kart numarası giriniz.',
        pattern: 'Geçersiz format.',
        equalto: 'Değerler eşleşmiyor.',
        minlength: 'Lütfen en az {0} karakter giriniz.',
        maxlength: 'Lütfen en fazla {0} karakter giriniz.',
        min: 'Lütfen {0} veya daha büyük bir değer giriniz.',
        max: 'Lütfen {0} veya daha küçük bir değer giriniz.',
        minfiles: 'Lütfen en az {0} dosya seçiniz.',
        maxfiles: 'Lütfen en fazla {0} dosya seçiniz.',
        phone: 'Lütfen geçerli bir telefon numarası giriniz.'
    };

    var TRIMMABLE = { text: 1, email: 1, tel: 1, url: 1, search: 1 };

    function isTurkish() {
        return location.pathname.split('/')[1] === 'tr';
    }

    function addPhoneRule() {
        if (!window.dmx || !dmx.rules || dmx.rules.phone) return;
        dmx.rules.phone = {
            message: 'Please enter a valid phone number.',
            validity: function (el) {
                var iti = (window.intlTelInputGlobals && intlTelInputGlobals.getInstance(el)) || el.__iti;
                if (!iti || typeof iti.isValidNumber !== 'function') return true;
                return iti.isValidNumber() !== false;
            }
        };
    }

    function localizeMessages() {
        addPhoneRule();
        if (!window.dmx || !dmx.rules || !isTurkish()) return;
        for (var name in TR) {
            if (dmx.rules[name]) dmx.rules[name].message = TR[name];
        }
    }

    function skip(el) {
        return !el || el.tagName !== 'INPUT' || !el.form || el.disabled || el.readOnly ||
            el.type === 'hidden' || el.hasAttribute('data-phone-full') ||
            el.hasAttribute('data-no-trim') || el.hasAttribute('dmx-tagify') ||
            el.getAttribute('is') === 'dmx-tagify';
    }

    function trimField(el) {
        if (skip(el) || !TRIMMABLE[el.type]) return;
        var trimmed = el.value.trim();
        if (trimmed === el.value) return;
        el.value = trimmed;
        el.dispatchEvent(new Event('input', { bubbles: true }));
    }

    function trimForm(form) {
        if (!form || !form.elements) return;
        for (var i = 0; i < form.elements.length; i++) trimField(form.elements[i]);
    }

    window.shTrimForm = trimForm;

    window.shValidateForm = function (form) {
        trimForm(form);
        return !window.dmx || !dmx.validate ? true : dmx.validate(form);
    };

    document.addEventListener('blur', function (e) {
        var el = e.target;
        if (skip(el)) return;
        trimField(el);
        if (!window.dmx || !dmx.validate) return;
        if (el.value || el.dirty) dmx.validate(el);
    }, true);

    document.addEventListener('submit', function (e) {
        trimForm(e.target);
    }, true);

    if (window.dmx && dmx.rules && Object.keys(dmx.rules).length) {
        localizeMessages();
    } else {
        document.addEventListener('DOMContentLoaded', localizeMessages);
    }
})();
